export const dataGridCustomizations = {
  MuiDataGrid: {
    styleOverrides: {
      root: {
        border: "none",
        backgroundColor: ({ theme }) => theme.palette.background.paper,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.04)",
        "& .MuiDataGrid-main": {
          overflow: "hidden"
        },
        "& .MuiDataGrid-row--dynamicHeight > .MuiDataGrid-cell": {
          overflow: "hidden",
          whiteSpace: "normal",
          lineHeight: "1.2",
          display: "flex",
          alignItems: "center",
          padding: "8px 10px"
        },
      },
      columnHeaders: {
        backgroundColor: ({ theme }) => theme.palette.background.default,
        borderBottom: ({ theme }) => `1px solid ${theme.palette.divider}`,
        minHeight: "52px !important",
      },
      columnHeader: {
        padding: "0 10px !important",
        height: "52px",
        "&:focus": {
          outline: "none"
        }
      },
      columnHeaderTitle: {
        fontWeight: 600,
        fontSize: "0.95rem",
        color: ({ theme }) => theme.palette.text.primary,
      },
      columnHeaderTitleContainer: {
        padding: "0"
      },
      cell: {
        borderBottom: ({ theme }) => `1px solid ${theme.palette.divider}`,
        fontSize: "0.95rem",
        height: "auto !important",
        minHeight: "52px !important",
        padding: "0 10px",
        color: ({ theme }) => theme.palette.text.primary,
        "&:focus": {
          outline: "none"
        }
      },
      row: {
        minHeight: "52px !important",
        height: "auto !important",
        "&:hover": {
          backgroundColor: ({ theme }) => theme.palette.action.hover
        }
      },
      cellCheckbox: {
        width: "80px !important",
        minWidth: "80px !important",
        maxWidth: "80px !important",
      },
      columnHeaderCheckbox: {
        width: "80px !important",
        minWidth: "80px !important",
        maxWidth: "80px !important",
      },
      detailPanelToggleCell: {
        display: "none !important",
        width: "0 !important",
        padding: "0 !important",
      },
      cellEmpty: {
        display: "none !important",
      },
      // Hide detail panel toggle
      '[data-field="__detail_panel_toggle__"]': {
        display: "none !important",
        width: "0 !important",
      },
    },
  },
  MuiGridToolbarContainer: {
    styleOverrides: {
      root: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: ({ theme }) => theme.palette.background.default,
        borderBottom: ({ theme }) => `1px solid ${theme.palette.divider}`,
      },
    },
  },
};
